import * as React from 'react';
import { useScrollIntoView } from '@grandvisionhq/utils';

/**
 * By setting the key attribute on this component and changing the value, you can re-mount this component
 * and trigger a remount to have it scroll to the element again. Example:
 * <ScrollIntoView key={changingValue}><Child /></ScrollIntoView>
 */ const ScrollIntoView = ({ children  })=>{
    const { elementRef , triggerScroll  } = useScrollIntoView();
    React.useEffect(()=>{
        triggerScroll();
    }, [
        triggerScroll
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "scroll-into-view",
        "data-t": "scroll-into-view",
        ref: elementRef
    }, children);
};

export { ScrollIntoView };
//# sourceMappingURL=ScrollIntoView.js.map
